import { makeStyles, tokens } from '@fluentui/react-components';

export const useSkeletonTableStyles = makeStyles({
    headerCell: {
        fontSize: '14px',
        fontWeight: tokens.fontWeightBold
    }
});